const _state = {
  studentSearchHistory: [],
  showStudentSearchBox: false,
  searchOpened: false,
  showFastSearch: false,
  webServiceStudentSearchEnabled: false,
  showTapRequestAlert: false,
  selectedStudent: JSON.parse(
    sessionStorage?.getItem('selected-student') ?? null
  ),
  studentId: JSON.parse(sessionStorage?.getItem('selected-student') ?? null)
    ?.studentId,
  isSearchStudentOpenedFromOutside: false,
  hideHistoryAndSelectAction: true,
};

export const initialState = () => _state;

export const state = initialState();
